// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__11o6D","productName":"Table_productName__EHlAV"};